import { connect } from 'react-redux';
import {
  getRecipesByTags,
  getFilters,
  getTotalTaggedRecipes,
  getCurrentRecipesPage,
  getFilteringOperation,
  getPaginatingOperation,
  getLoadingCount,
  getIsLastPage,
  getResponseCache,
  getFiltersModalOpen,
} from 'redux/modules/cms-hybrid-recipes-page/selectors';
import { getAccessToken } from 'redux/modules/sessions/selectors';
import { setFiltersModalOpen } from 'redux/modules/cms-hybrid-recipes-page/actions';
import RecipeCardsGrid from './RecipeCardsGrid';

export default connect(
  state => ({
    recipes: getRecipesByTags(state),
    filters: getFilters(state),
    jwt: getAccessToken(state),
    totaltaggedrecipes: getTotalTaggedRecipes(state),
    currentPage: getCurrentRecipesPage(state),
    filteringOperation: getFilteringOperation(state),
    paginatingOperation: getPaginatingOperation(state),
    loadingCount: getLoadingCount(state),
    isLastPage: getIsLastPage(state),
    responseCache: getResponseCache(state),
    isFiltersModalOpen: getFiltersModalOpen(state),
  }),
  dispatch => ({
    dispatch,
    setFiltersModalOpen: isOpen => dispatch(setFiltersModalOpen(isOpen)),
  }),
)(RecipeCardsGrid);
